import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { LicenseManager } from 'ag-grid-enterprise';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

export * from 'ag-grid-enterprise';

LicenseManager.setLicenseKey(
    'CompanyName=Xenial, Inc.,LicensedGroup=Denys-Artem,LicenseType=MultipleApplications,LicensedConcurrentDeveloperCount=6,LicensedProductionInstancesCount=2,AssetReference=AG-031033,SupportServicesEnd=8_September_2023_[v2]_MTY5NDEyNzYwMDAwMA==ac202ac1f993462ab36d4cd8f6d6e466',
);

if (environment.production) {
    enableProdMode();
}

platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => console.log(err));
